import '../../../../GlobalComponents/awc-reactjs-components/index.css'
import 'date-input-polyfill-react'
import 'react-bootstrap-typeahead/css/Typeahead-bs4.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'react-dd-menu/dist/react-dd-menu.css'

import {
    LockModal,
    Sticky,
    StickyContainer,
} from '../../../../GlobalComponents/awc-reactjs-components'
import React, { useEffect, useRef, useState } from 'react'

import { loginFormsRedirect } from '../../../utils'
import TimerWidget from '../../../widget/App'
import { getBaseURL } from '../../../../GlobalComponents/URLs'
import {
    modifyMissingRequiredLockLevelFields,
    numericStepToFixed,
    wordToBoolean,
    findCurrentLockLevel,
    updateLockedLevels,
    checkIfIsLocking,
    isValidDate,
    GetUniqueMultiValues,
} from './Helpers/FormContainerHelperFunctions'
import GetRenderData from './GetRenderData'
import { ReleaseModal } from '../../Modals/ReleaseModal'
import {
    handleAssemblyIDSearch,
    handleAssembliesList,
    handleAssemblyIDSelection,
    handleCreateNewUidClick,
} from './Helpers/FormHandlers'
import { useRecoilState } from 'recoil'
import {
    formIdAtom,
    recordIdAtom,
    fieldChangedAtom,
    lockedLevelsAtom,
    recordLockLevelAtom
} from '../../../State/Atoms/FormProps/FormPropsAtoms'
import { saveTimeAtom, savingAtom, baseDataAtom } from '../../../State/Atoms/FormData/FormDataAtoms'
import { sendLog } from '../../Logging/SendLog'
import ConfirmModal from '../../Modals/ConfirmModal'

var Promise = require('es6-promise-polyfill').Promise
/*
version3: added picture length in error log
version4: changed webcam to allow chaining pictures. Changed save to not redirect. fixed an issue causing extra autosaves. 
Made autosave fail limit (mainly for when someone leaves browser open with no cookies)
version5: added ability to lock and unlock individual levels through menu
*/
const versionNumber = 5
const RENEW_EVERY_X_MIN = 5 // locks get killed every 10
const TIMEOUT_SECONDS = 45
const MAX_RENEW = 60 / RENEW_EVERY_X_MIN // renews every 5 minutes
const WARN_RENEW = 45 / RENEW_EVERY_X_MIN
const SCREENS = {
    LOCKED: 'locked',
    DEFAULT: 'default',
    WRONG_USER: 'wrong user',
    NO_RECORD: 'no record',
}
var numberPicturesSending = 0

// to prevent double sending
var sendingLogs = 0

const EVENTS = {
    CHANGE_STAGE: 1,
    START_TIMER: 2,
    STOP_TIMER: 3,
    SDS_EMAIL: 4,
    UPDATE_QUERYFIELD: 5,
    PRETEST_FAIL_EMAIL: 6,
    SEND_STAGE_EMAIL: 7,
}

const ERRORS = {
    CANT_COMPLETE: 1,
}

const AVERAGING_FIELDS = {
    PopValue: true,
    TestValue: true,
}
const VALUE_AVERAGE_MAP = {
    PopValue: 'PopAverage',
    TestValue: 'TestAverage',
}
// current place
// SetPressureUOM -> FinalPopTestUOM
// BackPressureUOM -> BPTestUnits
const FREEZE_UOM_START = {
    SetPressureUOM: true,
    BackPressureUOM: true,
}

const FREEZE_UOM_MAP = {
    SetPressureUOM: 'FinalPopTestUOM',
}
const sendStageEmail = (recordId, stage) => {
    let url = `${getBaseURL()}webapi/tags/stageemail/${recordId}/${stage}`
    // use fetch to get form values
    fetch(url, {
        credentials: 'include',
    })
}

const sendSDSEmail = (recordId) => {
    let url = `${getBaseURL()}webapi/form/sdsemail/${recordId}`
    // use fetch to get form values
    fetch(url, {
        credentials: 'include',
    })
}

const sendPretestFailEmail = (recordId, type) => {
    let url = `${getBaseURL()}webapi/form/pretestemail/${recordId}/${type}`
    fetch(url, {
        credentials: 'include',
    })
}

const updateQueryField = (recordId, queryField, newValue) => {
    let url = `${getBaseURL()}webapi/form/updateQueryField/${recordId}/${queryField}`
    // use fetch to get form values
    fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify(newValue),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

const fetchOnDockDate = async (recordId) => {
    let url = `${getBaseURL()}webapi/form/orderTagODD/${recordId}`
    let req = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    let json = await req.json()
    return json
}

const UNTHROTTLED_EVENTS = {
    [EVENTS.UPDATE_QUERYFIELD]: true,
}
class EventQueue {
    constructor(widgetRef) {
        this.events = []
        this.widgetRef = widgetRef
        this.triggeredEvents = {}
        this.triggeredStageChanges = {}
    }

    enqueueEvent(event, param, fieldId) {
        // stages get run once per parameter per session
        if (event === EVENTS.CHANGE_STAGE) {
            let key = param.ChangeStageTo
            if (!this.triggeredStageChanges[key]) {
                this.events.push({ event, param })
                this.triggeredStageChanges[key] = true
            }
        } else {
            // each fieldId event combo can only be triggered once per session
            let key = `e${event}f${fieldId}`
            if (!this.triggeredEvents[key] || UNTHROTTLED_EVENTS[event]) {
                this.events.push({ event, param })
                this.triggeredEvents[key] = true
            }
        }
    }

    flush(recordId) {
        while (this.events.length > 0) this.dequeueEvent(recordId)
    }

    dequeueEvent(recordId) {
        if (this.events.length === 0) {
            return
        }
        let { event, param } = this.events[0]
        if (event === EVENTS.CHANGE_STAGE) {
            let { ChangeStageTo, CanCompleteAs } = { ...param }
            if (this.widgetRef.current)
                this.widgetRef.current.changeStage(ChangeStageTo, CanCompleteAs)
        } else if (event === EVENTS.START_TIMER) {
            if (this.widgetRef.current) this.widgetRef.current.startTimer(param)
        } else if (event === EVENTS.STOP_TIMER) {
            if (this.widgetRef.current) this.widgetRef.current.stopTimer()
        } else if (event === EVENTS.SDS_EMAIL) {
            sendSDSEmail(recordId)
        } else if (event === EVENTS.UPDATE_QUERYFIELD) {
            let { queryField, newValue } = { ...param }
            updateQueryField(recordId, queryField, newValue)
        } else if (event === EVENTS.PRETEST_FAIL_EMAIL) {
            sendPretestFailEmail(recordId, param.type)
        } else if (event === EVENTS.SEND_STAGE_EMAIL) {
            //param = stage name
            sendStageEmail(recordId, param)
        }
        this.events = this.events.slice(1)
    }
}

function fetchWithTimeout(url, options, timeout = 7000) {
    return Promise.race([
        fetch(url, options),
        new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), timeout)),
    ])
}

// include props parameter to access values passed in as properties from parent component (App)
export default React.forwardRef((props, ref) => {
    const [lockedLevels, setLockedLevels] = useRecoilState(lockedLevelsAtom)
    const [disableSubmits, setDisableSubmits] = useState(false)
    const [canUnlock, setCanUnlock] = useState(false)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [lockState, setLockState] = useState({ lockedBy: '', locked: false })
    const autosaveId = useRef(-1)
    const renewCount = useRef(0)
    const renewFailCount = useRef(0)
    const lockInfo = useRef({})
    const refRecordId = useRef(-1)
    const [currentUser, setCurrentUser] = useState('NOT SET')
    const [formOrError, setFormOrError] = useState(null)
    const [formViewId, setFormViewId] = useState(0)
    //const [data, setData] =useRecoilState(formDataAtom)
    const [data, setData] = useState(false)
    //const [fieldChanged, setFieldChanged] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0) // eslint-disable-line no-unused-vars
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [showLockModal, setShowLockModal] = useState(false)
    const [showReleaseModal, setShowReleaseModal] = useState(false)
    const [showLockedOutScreen, setShowLockedOutScreen] = useState(false)
    const [isPOModalVisible, setPOModalVisible] = useState(false)
    const [activeScreen, setActiveScreen] = useState(SCREENS.DEFAULT)
    const [isFirstError, setIsFirstError] = useState(true)
    const [visibleSectionFields, setVisibleSectionFields] = useState(new Map())
    const [requiredLockLevelFields, setRequiredLockLevelFields] = useState([])
    const [missingRequiredLockLevelFields, setMissingRequiredLockLevelFields] = useState([])
    const [recordLockLevel, setRecordLockLevel] = useRecoilState(recordLockLevelAtom)
    const [newRecordLockLevel, setNewRecordLockLevel] = useState(0)
    const [clearSig, setClearSig] = useState(false)
    const [numLevels, setNumLevels] = useState(-1)
    const [recordId, setRecordId] = useRecoilState(recordIdAtom)
    const [signatureFields, setSignatureFields] = useState([])
    const [currentModal, setCurrentModal] = useState(null)
    const [defaultData, setDefaultData] = useState([])
    const [writer, setWriter] = useState(false)
    const widgetRef = useRef(null)
    const [saving, setSaving] = useRecoilState(savingAtom)
    const [savedTime, setSavedTime] = useRecoilState(saveTimeAtom)
    const [saveButtonRendered, setSaveButtonRendered] = useState(true)
    const [timerRefresh, setTimerRefresh] = useState(new Date()) // used for autosave
    const eventQueueRef = useRef(new EventQueue(widgetRef))
    const [lastUpdateInfo, setLastUpdateInfo] = useState({
        info: {},
        time: new Date(),
    })
    const lockedLevelsArray = lockedLevels ? lockedLevels.split('|') : []
    const [isLocking, setIsLocking] = useState(false)
    const [isQRModalVisible, setQRModalVisible] = useState(false)
    const [isAssemblyModalVisible, setAssemblyModalVisible] = useState(false)
    const [isAssemblySearchModalVisible, setIsAssemblySearchModalVisible] = useState(false)
    const [apiData, setApiData] = useState(null) // State to store API response
    const [assemblyError, setAssemblyError] = useState(null) // State to handle errors
    const [assemblyInfo, setAssemblyInfo] = useState(null) // State to handle errors
    const [showAssemblyAlert, setShowAssemblyAlert] = useState(false)
    const [showAssemblyInfo, setShowAssemblyInfo] = useState(false)
    const [aWCAssemblyUIDList, setAWCAssemblyUIDList] = useState(null)
    const [formId, setFormId] = useRecoilState(formIdAtom)
    const [fieldChanged, setFieldChanged] = useRecoilState(fieldChangedAtom)
    const [showAssemblyListModal, setShowAssemblyListModal] = useState(false)
    const [baseData, setBaseData] = useRecoilState(baseDataAtom)

    const appLock = lockState.locked
    const [selectedValue, setSelectedValue] = useState('')
    React.useImperativeHandle(ref, () => ({
        // to be called after saves resolve -- post save events like making pdf
        flushEventQueue: (recordId) => {
            eventQueueRef.current.flush(recordId)
        },
    }))
    const handleQROpenModal = () => {
        setQRModalVisible(true)
    }

    const handleQRCloseModal = () => {
        setQRModalVisible(false)
    }

    const handleAssemblyOpenModal = () => {
        setAssemblyModalVisible(true)
    }

    const handleAssemblyCloseModal = () => {
        setAssemblyModalVisible(false)
    }

    const handleAssemblyResultsCloseModal = () => {
        setIsAssemblySearchModalVisible(false)
    }

    const handlePOCloseModal = () => {
        setPOModalVisible(false)
    }

    const handleConfirmClose = () => {
        setShowConfirmModal(false)
    }
    const handleScanComplete = (uValue) => {
        handleAssemblyIDSearch(
            uValue,
            data,
            setApiData,
            setIsAssemblySearchModalVisible,
            setAssemblyError
        )
    }

    const handlePOComplete = (uValue) => {
        handleAssemblyIDSelection(
            data,
            setAWCAssemblyUIDList,
            setData,
            setAssemblyInfo,
            setAssemblyError,
            props.handleSubmitWithData,
            uValue,
            setPOModalVisible
        )
    }
    const handleAssemblySelectionWrapper = () => {
        handleAssemblyIDSelection(
            data,
            setAWCAssemblyUIDList,
            setData,
            setAssemblyInfo,
            setAssemblyError,
            props.handleSubmitWithData,
            '',
            setPOModalVisible,
            isPOModalVisible,
            setShowAssemblyListModal
        )
    }
    const addAssemblyList = (uValue) => {
        handleAssembliesList(uValue, setAWCAssemblyUIDList, setAssemblyError)
    }

    const newAssemblyIDClick = () => {
        handleCreateNewUidClick(data, setData, setAssemblyError)
    }

    const handleAssemblySearchConfirm = () => {
        const responseData = apiData
        const newData = (data) => {
            const serialNumberField = data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'SerialNumber'
            )

            if (serialNumberField) {
                serialNumberField.StringFieldValue = responseData.SerialNumber
            }
            data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'TagUID'
            ).NumericFieldValue = responseData.AWCAssemblyID

            data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'BillToName'
            ).StringFieldValue = responseData.CustomerName
            return { ...data }
        }
        setData(newData)
        addAssemblyList(responseData.AWCAssemblyID)
        props.handleSubmitWithData(data)
    }

    const handleAssemblyIdChange = (assemblyId) => {
        const foundAssembly = aWCAssemblyUIDList.find(
            (assembly) => assembly.AWCAssemblyID === assemblyId
        )
        setData((data) => {
            data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'TagUID'
            ).NumericFieldValue = assemblyId
            if (foundAssembly) {
                data.FormSectionFieldValueView.find(
                    (d) => d.FieldNameQuery === 'SerialNumber'
                ).StringFieldValue = foundAssembly.SerialNumber
            }
            return { ...data }
        })
    }

    const handleReadOnly = (e) => {
        setLockState((prev) => {
            return { ...prev, locked: true }
        })
    }

    useEffect(() => {
        if (assemblyError) {
            setShowAssemblyAlert(true) // Show the alert when assemblyError has a value

            // Hide the alert after 10 seconds
            const timer = setTimeout(() => {
                setShowAssemblyAlert(false)
            }, 10000)

            // Cleanup the timer when the component unmounts or when assemblyError changes
            return () => clearTimeout(timer)
        }
    }, [assemblyError])

    useEffect(() => {
        if (assemblyInfo) {
            setShowAssemblyInfo(true) // Show the alert when assemblyError has a value

            // Hide the alert after 10 seconds
            const timer = setTimeout(() => {
                setShowAssemblyInfo(false)
            }, 10000)

            // Cleanup the timer when the component unmounts or when assemblyError changes
            return () => clearTimeout(timer)
        }
    }, [assemblyInfo])

    const setDefaultValue = (row) => {
        switch (row.DataType) {
            case 'Numeric':
                row.NumericFieldValue = parseFloat(row.DefaultValue)
                break
            case 'Boolean':
                row.BooleanFieldValue = wordToBoolean(row.DefaultValue)
                break
            default:
                row.StringFieldValue = row.DefaultValue
                break
        }
    }
    const setDefaults = (dict) => {
        dict.FormSectionFieldValueView.forEach((x) => {
            let options = dict.FormSectionFieldOption.filter(
                (y) => y.FormSectionFieldId === x.FormSectionFieldId
            )
            let defaultOpts = options.filter((y) => y.OptionIsDefault)
            if (defaultOpts.length > 0) {
                if (x.ValidationType.toUpperCase() === 'MULTI-SELECT') {
                    defaultOpts.forEach((y, i) => {
                        dict.FormSectionFieldMultiValue.push({
                            RecordId: -1,
                            FormSectionFieldId: x.FormSectionFieldId,
                            ValueId: -1 * i - 1,
                            StringFieldValue: y.OptionValue,
                        })
                    })
                } else {
                    x.StringFieldValue = defaultOpts[0].OptionValue
                }
            }
            // setDefault for non option fields
            else {
                if (x.DefaultValue.length > 0) setDefaultValue(x)
            }
        })
    }

    // useEffect(() => {
    //     let sendInt = setInterval(function () {
    //         sendLockLog(false)
    //     }, 60000)
    //     // renew every 5 min
    //     let renewInt = setInterval(sendRenew, RENEW_EVERY_X_MIN * 60000)
    //     // let autoInt = setInterval(autosave, SECONDS_BETWEEN_AUTOSAVES * 1000)
    //     return () => {
    //         clearInterval(sendInt)
    //         // clearInterval(autoInt)
    //         clearInterval(renewInt)
    //     }
    // }, [data, refRecordId.current, props.shouldAutosave, autosaveId.current, showLockedOutScreen])

    useEffect(() => {
        // update temp values
        if (
            data &&
            data.FormSectionFieldValueView[0].RecordId < 0 &&
            props.defaultData &&
            props.defaultData.FormSectionFieldValueView[0].RecordId > 0
        )
            setData(JSON.parse(JSON.stringify(props.defaultData)))
        else {
            if (
                data &&
                defaultData &&
                props.defaultData &&
                JSON.stringify(props.defaultData) !== JSON.stringify(defaultData.current)
            ) {
                setData((data) => {
                    if (data.FormSectionFieldValueViewDeleted)
                        data.FormSectionFieldValueViewDeleted =
                            data.FormSectionFieldValueViewDeleted.filter((row) => !row.toClean)
                    if (data.FormSectionFieldMultiValueDeleted)
                        data.FormSectionFieldMultiValueDeleted =
                            data.FormSectionFieldMultiValueDeleted.filter((row) => !row.toClean)
                    if (data.FormSectionFieldAttachmentMultiValueDeleted)
                        data.FormSectionFieldAttachmentMultiValueDeleted =
                            data.FormSectionFieldAttachmentMultiValueDeleted.filter(
                                (row) => !row.toClean
                            )
                    if (data.FormSectionFieldAttachmentDeleted)
                        data.FormSectionFieldAttachmentDeleted =
                            data.FormSectionFieldAttachmentDeleted.filter((row) => !row.toClean)

                    // update temp values in data from new default data
                    props.defaultData.FormSectionFieldMultiValue.forEach((row) => {
                        let dataRow = data.FormSectionFieldMultiValue.find(
                            (dRow) =>
                                dRow.FormSectionFieldId == row.FormSectionFieldId &&
                                dRow.StringFieldValue === row.StringFieldValue
                        )
                        if (dataRow) dataRow.ValueId = row.ValueId
                    })

                    props.defaultData.FormSectionFieldAttachmentMultiValue.forEach((row) => {
                        let dataRow = data.FormSectionFieldAttachmentMultiValue.find(
                            (dRow) =>
                                dRow.FormSectionFieldId == row.FormSectionFieldId &&
                                dRow.SystemFilename == row.SystemFilename &&
                                dRow.StringFieldValue === row.StringFieldValue
                        )
                        if (dataRow) dataRow.ValueId = row.ValueId
                    })

                    props.onFormFieldChange({ ...data }, false)
                    return { ...data }
                })
                defaultData.current = JSON.parse(JSON.stringify(props.defaultData))
            }
        }
        // setDisableSubmits(false)
    }, [props.defaultData, defaultData])

    useEffect(() => {
        // update temp values
        const updateKeys = {
            StringFieldValue: true,
            NumericFieldValue: true,
            BooleanFieldValue: true,
            MemoFieldValue: true,
            DateFieldValue: true,
        }
        if (props.updateInfo && props.updateInfo.time > lastUpdateInfo.time) {
            setData((data) => {
                if (data.FormSectionFieldMultiValueDeleted)
                    data.FormSectionFieldMultiValueDeleted =
                        data.FormSectionFieldMultiValueDeleted.filter((row) => !row.toClean)
                // update temp values in data from new default data
                props.updateInfo.info.FormSectionFieldValueView.forEach((row) => {
                    let dataRow = data.FormSectionFieldValueView.find(
                        (dRow) => dRow.FormSectionFieldId === row.FormSectionFieldId
                    )
                    if (dataRow) {
                        Object.keys(row).forEach((key) => {
                            if (key in updateKeys) {
                                dataRow[key] = row[key]
                            }
                        })
                    }
                })
                props.onFormFieldChange({ ...data }, false)
                return { ...data }
            })
            setLastUpdateInfo(props.updateInfo)
        }
    }, [props.updateInfo])

    useEffect(() => {
        refRecordId.current = recordId
    }, [recordId])
    const { formid, recordid, onFormLoaded } = props
    useEffect(() => {
        if (props.reload) {
            setFormOrError(null)
        }
    }, [props.reload])

    useEffect(() => {
        // get form field and values
        const _loadFormData = () => {
            // don't waste time sending a request with init values
            // this will be called again once props are loaded into state
            let currentUsername = ''
            if (formid > 0 || recordid > 0) {
                // set state variable for componentDidUpdate to know data has been requested
                setFormOrError('pending')

                // use fetch to get form values
                fetch(
                    `${getBaseURL()}webapi/form/${recordid > 0 ? `record/${recordid}` : `form/${formid}`
                    }`,
                    {
                        credentials: 'include',
                    }
                )
                    .then((response) => {
                        if (response.ok) {
                            if (response.status === 204) {
                                setActiveScreen(SCREENS.NO_RECORD)
                                props.setFormLoaded(true)
                                setFormOrError('form')
                                setData(true)
                                throw new Error('No record.')
                            }
                            // throwing this if you don't have access to the form
                            if (
                                response.headers.get('Authorized') &&
                                response.headers.get('Authorized').toLowerCase() === 'false'
                            ) {
                                setActiveScreen(SCREENS.WRONG_USER)
                                // data = false is used as a loaded check
                                setData(true)
                                //same
                                props.setFormLoaded(true)
                                throw new Error('User not permitted.')
                            } else if (
                                response.headers.get('Authorized') &&
                                response.headers.get('Authorized').toLowerCase() === 'write'
                            ) {
                                setWriter(true)
                            }
                            // currentUsername = response.headers.get("Username");
                            return response.text()
                        }

                        if (response.status === 400 || response.status === 401) {
                            // status 400 = bad request
                            // status 401 = unathorized
                            // webApi detected no cookies. alert then redirect.
                            setAssemblyError('Web Api detected no cookies. Please login.')
                            let redirectPath
                            if (recordid > 0) {
                                redirectPath = `/FormGeneric/record/${recordid}`
                            } else {
                                redirectPath = `/FormGeneric/form/${formid}/${props.assetType}/${props.serviceType}`
                            }
                            loginFormsRedirect(redirectPath)
                        }
                        throw new Error('Network response was not ok.')
                    })
                    .then((responseText) => {
                        // convert responseText (json text) into JSON object for easy consumption
                        const response = JSON.parse(responseText)
                        if (response.Variables) {
                            // replace variables
                            let variables = {}
                            response.Variables.map((x) => {
                                variables[x.VariableName] = x.VariableValue
                            })
                            response.FormSectionFieldValueView.map((x) => {
                                let res = x.FieldName
                                response.Variables.map((y) => {
                                    if (x.FieldName.includes(`{${y.VariableName}}`))
                                        res = res.replace(`{${y.VariableName}}`, y.VariableValue)
                                })
                                x.FieldName = res
                            })
                            response.FormSectionFieldMultiValue.map((x) => {
                                let res = x.StringFieldValue
                                response.Variables.map((y) => {
                                    if (x.StringFieldValue.includes(`{${y.VariableName}}`))
                                        res = res.replace(`{${y.VariableName}}`, y.VariableValue)
                                })
                                x.StringFieldValue = res
                            })
                            let newFormSectionFieldMultiValue = GetUniqueMultiValues(
                                response.FormSectionFieldMultiValue
                            )
                            response.FormSectionFieldMultiValue = newFormSectionFieldMultiValue
                            response.FormSectionFieldOption.map((x) => {
                                let res = x.OptionText
                                response.Variables.map((y) => {
                                    if (x.OptionText.includes(`{${y.VariableName}}`))
                                        res = res.replace(`{${y.VariableName}}`, y.VariableValue)
                                })
                                x.OptionText = res
                                // values
                                res = x.OptionValue
                                response.Variables.map((y) => {
                                    if (x.OptionValue.includes(`{${y.VariableName}}`))
                                        res = res.replace(`{${y.VariableName}}`, y.VariableValue)
                                })
                                x.OptionValue = res
                            })
                        }
                        const baseResp = JSON.parse(JSON.stringify(response))
                        // make sure data was returned FormRecord Added for when records are auto generated (they're empty)
                        if (
                            response.FormSectionFieldValueView.length > 0 ||
                            response.FormRecord.length > 0
                        ) {
                            // process metadata like lock info
                            if (response.MetaData) {
                                let metadata = JSON.parse(JSON.stringify(response.MetaData))
                                lockInfo.current = { MetaData: metadata }
                                if (response.MetaData[0].HasLock === false) {
                                    setLockState({
                                        lockedBy: response.MetaData[0].LockOwner,
                                        locked: true,
                                    })
                                }
                                if (response.MetaData[0].CanUnlockAllLevels === true) {
                                    setCanUnlock(true)
                                }
                                setCurrentUser(response.MetaData[0].CurrentUser)
                            }
                            // set defaults if this is new form
                            if (recordid < 0) setDefaults(response)
                            let newTitle = response.FormSectionFieldValueView[0].Form
                            let tagNumber = response.FormSectionFieldValueView.find(
                                (x) => x.FieldNameQuery.trim().toUpperCase() === 'TAGNUMBER'
                            )
                            newTitle +=
                                tagNumber && tagNumber.StringFieldValue
                                    ? ` - ${tagNumber.StringFieldValue}`
                                    : ''

                            document.title = newTitle
                            // set state variable for componentDidUpdate to know data has been retrieved
                            setFormOrError('form')

                            const updatedFields = response.FormSectionFieldValueView.map((field) =>
                                field.FieldNameQuery === 'OrderNumber'
                                    ? {
                                        ...field,
                                        StringFieldValue: response.OrderInfo[0].OrderNumber,
                                    }
                                    : field.FieldNameQuery === 'TagUID'
                                        ? {
                                            ...field,
                                            NumericFieldValue: response.OrderInfo[0].AWCAssemblyId,
                                        }
                                        : field
                            )
                            const updatedResponse = {
                                ...response,
                                FormSectionFieldValueView: updatedFields,
                            }

                            // save data in data state variable
                            setData(updatedResponse)
                            const awcid =
                                response.FormSectionFieldValueView.find(
                                    (d) => d.FieldNameQuery === 'TagUID'
                                )?.NumericFieldValue || null
                            const serialNumber =
                                response.FormSectionFieldValueView.find(
                                    (d) => d.FieldNameQuery === 'SerialNumber'
                                )?.StringFieldValue || null
                            if (awcid) {
                                handleAssembliesList(awcid, setAWCAssemblyUIDList, setAssemblyError)
                            }
                            setRecordId(response.FormSectionFieldValueView[0].RecordId)
                            // save initial lock level
                            setRecordLockLevel(
                                response.FormRecord.length > 0
                                    ? response.FormRecord[0].LockLevel
                                    : 0
                            )
                            if (response.FormRecord.length > 0) {
                                response.FormRecord[0].LockedLevels
                                    ? setLockedLevels(response.FormRecord[0].LockedLevels)
                                    : setLockedLevels('')
                            }
                            // save list of sections and the fields that trigger their visibility
                            setVisibleSectionFields(
                                getUniqueVisibleSectionFields(response.FormSectionFieldValueView)
                            )
                            // save list of lock levels and their required fields
                            setRequiredLockLevelFields(
                                getRequiredLockLevelFields(response.FormSectionFieldValueView)
                            )
                            // formId was determined, data retrieved. pass back up to parent component (App) for re-rendering form
                            props.onFormLoaded(baseResp)
                            setBaseData(JSON.parse(JSON.stringify(response)))
                            // really just for checking for changes
                            setDefaultData(JSON.parse(JSON.stringify(baseResp)))
                        } else {
                            // if no data returned for provided formId/recordId, let them know
                            alert('Form not found!')
                            // set state variable for componentDidUpdate to know data has been retrieved
                            setFormOrError('error')
                        }
                    })
                    .catch((error) => {
                        console.error(
                            'There has been a problem with your fetch operation: ',
                            error.message
                        )
                    })
            } else if (props.recoveryId > -1) {
                // important: fetch form separately instead of getting it from the 1 api request because we need the plain form to setDefaultData

                // get recovered portion
                let recoveryUrl =
                    getBaseURL() + 'webapi/form/recoverForm/' + props.recoveryId.toString()
                fetch(recoveryUrl, {
                    credentials: 'include',
                })
                    .then((resp) => {
                        if (resp.ok) return resp.json()
                        else throw new Error('failed to fetch ' + recoveryUrl)
                    })
                    .then((json) => {
                        let record = JSON.parse(json[0].rawJson)
                        // get form that is the base of the record
                        let formUrl =
                            getBaseURL() +
                            'webapi/form/form/' +
                            record.FormSectionFieldValueView[0].FormId
                        fetch(formUrl, {
                            credentials: 'include',
                        })
                            .then((resp) => {
                                if (resp.ok) return resp.json()
                                else throw new Error('in Recovery: failed to fetch ' + formUrl)
                            })
                            .then((plainForm) => {
                                // smush them together
                                // this makes form and plainForm have different references
                                let form = JSON.parse(JSON.stringify(plainForm))

                                //copy all attachments over
                                form.FormSectionFieldAttachment = record.FormSectionFieldAttachment

                                // copy fields over if they are in the record
                                for (let i = 0; i < form.FormSectionFieldValueView.length; i++) {
                                    if (
                                        form.FormSectionFieldValueView[i].FormSectionFieldId ===
                                        record.FormSectionFieldValueView[i].FormSectionFieldId
                                    ) {
                                        Object.assign(
                                            form.FormSectionFieldValueView[i],
                                            record.FormSectionFieldValueView[i]
                                        )
                                        // !IMPORTANT stringify these as they come in -- need to be string when you save them -- DS will cast column to int if first value is a number and an int
                                        if (
                                            typeof form.FormSectionFieldValueView[i]
                                                .NumericFieldValue === 'number'
                                        )
                                            form.FormSectionFieldValueView[i].NumericFieldValue =
                                                form.FormSectionFieldValueView[
                                                    i
                                                ].NumericFieldValue.toString()
                                    }
                                    // put the recordId in the base form for comparison later -- don't want to change handleSubmits find function
                                    plainForm.FormSectionFieldValueView[i].RecordId =
                                        record.FormSectionFieldValueView[i].RecordId
                                }
                                form.FormSectionFieldAttachmentMultiValue =
                                    record.FormSectionFieldAttachmentMultiValue
                                form.FormSectionFieldOption = record.FormSectionFieldOption
                                form.FormSectionFieldMultiValue = record.FormSectionFieldMultiValue

                                setFormOrError('form')
                                // save data in data state variable

                                setData(form)
                                // save initial lock level
                                setRecordLockLevel(
                                    form.FormRecord.length > 0 ? form.FormRecord[0].LockLevel : 0
                                )
                                if (response.FormRecord.length > 0) {
                                    response.FormRecord[0].LockedLevels
                                        ? setLockedLevels(response.FormRecord[0].LockedLevels)
                                        : setLockedLevels('')
                                }
                                // save list of sections and the fields that trigger their visibility
                                setVisibleSectionFields(
                                    getUniqueVisibleSectionFields(form.FormSectionFieldValueView)
                                )
                                // save list of lock levels and their required fields
                                setRequiredLockLevelFields(
                                    getRequiredLockLevelFields(form.FormSectionFieldValueView)
                                )
                                setRecordId(form.FormSectionFieldValueView[0].RecordId)
                                // these won't be on old recovered forms -- can remove the if's after 2/15/2021
                                if (record.autosaveMetadata.assetType)
                                    props.setAssetType(record.autosaveMetadata.assetType)
                                if (record.autosaveMetadata.serviceType)
                                    props.setServiceType(record.autosaveMetadata.serviceType)
                                if (record.autosaveMetadata.lockLevel) {
                                    setRecordLockLevel(record.autosaveMetadata.lockLevel)
                                }

                                // formId was determined, data retrieved. pass back up to parent component (App) for re-rendering form
                                props.onFormLoaded(form)

                                // have to do this because this is how data is passed in this app
                                // onFormLoaded sets the default data that is compared against in the save function
                                props.onFormLoaded(plainForm, record.autosaveMetadata.lockLevel)
                                // tldr sets data to the appropriate values
                                props.onFormFieldChange(form)
                            })
                    })
            }
        }

        // only load the form again if it hasn't been successfully loaded yet
        if (formOrError === null) _loadFormData()
    }, [formid, recordid, onFormLoaded, formOrError])

    const updateOnDockDate = async (recordId) => {
        const onDockDate = await fetchOnDockDate(recordId)
        if (onDockDate) {
            setData((data) => {
                data.FormSectionFieldValueView.find(
                    (d) => d.FieldNameQuery === 'OnDockDate'
                ).DateFieldValue = onDockDate.OnDockDate
                return { ...data }
            })
        }
    }
    useEffect(() => {
        if (!clearSig) return
        setData((data) => {
            signatureFields.forEach((ele) => {
                if (recordLockLevel < ele.LockLevel) {
                    data.FormSectionFieldValueView[ele.index].StringFieldValue = ''
                    // Current Field value
                    let currentFieldId = parseInt(
                        data.FormSectionFieldValueView[ele.index].FormSectionFieldId
                    )

                    data.FormSectionFieldValueView.map((d, index) => {
                        // Check for current field
                        if (d.FormSectionFieldId === currentFieldId) {
                            // Grab next field index
                            const nextField = data.FormSectionFieldValueView[index + 1]

                            // Check if next field exists
                            if (nextField) {
                                // Clear next field if it's date and in the same form section id
                                // Check if it's a date and in the same FormSectionId
                                if (
                                    nextField.DataType === 'Date' &&
                                    nextField.FormSectionId ===
                                    data.FormSectionFieldValueView[ele.index].FormSectionId
                                ) {
                                    nextField.DateFieldValue = ''
                                } // Else, check if the previous field is a date and in the same FormSectionId
                                else {
                                    if (index > 0) {
                                        // Previous field
                                        const previousField =
                                            data.FormSectionFieldValueView[index - 1]
                                        if (previousField) {
                                            if (
                                                previousField.DataType === 'Date' &&
                                                previousField.FormSectionId ===
                                                data.FormSectionFieldValueView[ele.index]
                                                    .FormSectionId
                                            ) {
                                                previousField.DateFieldValue = ''
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
            })
            return { ...data }
        })
        setMissingRequiredLockLevelFields((missingRequiredLockLevelFields) => {
            signatureFields.forEach((ele) => {
                if (
                    !checkIfIsLocking(ele.lockLevel, lockedLevels) &&
                    (missingRequiredLockLevelFields[ele.LockLevel] === undefined ||
                        !missingRequiredLockLevelFields[ele.LockLevel].find(
                            (x) => x === ele.FormSectionFieldId
                        ))
                ) {
                    if (!missingRequiredLockLevelFields[ele.LockLevel])
                        missingRequiredLockLevelFields[ele.LockLevel] = []
                    missingRequiredLockLevelFields[ele.LockLevel].push(ele.FormSectionFieldId)
                }
                // data.FormSectionFieldValueView[ele.index].StringFieldValue = '';
            })
            return [...missingRequiredLockLevelFields]
        }, [])

        setClearSig(false)
    }, [clearSig, recordLockLevel])

    const getUniqueVisibleSectionFields = (arr) => {
        const result = new Map()
        arr.forEach(function (item) {
            if (!result.has(item.FormSectionId) && parseInt(item.VisibilityControlFieldId) > 0)
                result.set(item.FormSectionId, item.VisibilityControlFieldId)
        })
        return result
    }

    const getRequiredLockLevelFields = (arr) => {
        const result = []
        let maxLevel = 0
        arr.forEach((item) => {
            let reqLL = item.RequiredLockLevel
            maxLevel = reqLL > maxLevel ? reqLL : maxLevel
            if (reqLL > 0) {
                if (result[reqLL] === undefined) result[reqLL] = [item.FormSectionFieldId]
                else result[reqLL].push(item.FormSectionFieldId)
            }
        })
        for (let i = 0; i < maxLevel; i++) {
            if (result[i] === undefined) result[i] = []
        }
        return result
    }

    const onSubmit = (e) => {
        if (lockState.locked) return
        setSaving(true)
        if (data) {
        }
        // Checking required here because custom validity was going over combobox -- moving away from html forms
        let newFormSectionFieldValueView = data.FormSectionFieldValueView.map((fdata) => {
            let isRequired = fdata.IsRequired && fdata.RequiredLockLevel <= recordLockLevel
            if (fdata.ValidationType.toUpperCase() === 'COMBOBOX' && isRequired) {
                return {
                    ...fdata,
                    invalid: fdata.StringFieldValue.trim().length === 0 ? true : false,
                }
            }
            return { ...fdata }
        })
        setData((data) => {
            data.FormSectionFieldValueView = newFormSectionFieldValueView
            data.FormSectionFieldValueViewDeleted &&
                data.FormSectionFieldValueViewDeleted.forEach((row) => (row.toClean = true))
            data.FormSectionFieldMultiValueDeleted &&
                data.FormSectionFieldMultiValueDeleted.forEach((row) => (row.toClean = true))
            data.FormSectionFieldAttachmentMultiValueDeleted &&
                data.FormSectionFieldAttachmentMultiValueDeleted.forEach(
                    (row) => (row.toClean = true)
                )
            data.FormSectionFieldAttachmentDeleted &&
                data.FormSectionFieldAttachmentDeleted.forEach((row) => (row.toClean = true))
            return { ...data }
        })
        let someInvalid = newFormSectionFieldValueView.some((row) => row.invalid)

        if (someInvalid) {
            setAssemblyError('Please fill in required fields')
            if (e) e.preventDefault()
            return
        }
        // keep track of this so we know if save is autosave or regular saved -- put on window to avoid hassle and the info shouldnt be needed anywhere else
        window.clickedSubmit = true

        if (e) e.preventDefault()
        props.handleSubmitWithData(data)

        setSaving(false)
        const time = new Date().toLocaleString('en-US', {
            timeZone: 'America/Chicago',
        })
        if (data.Form && data.Form.length > 0) {
            if (data.Form[0].Purpose.trim().toUpperCase() !== 'PERFORMANCE REVIEW') {
                setSavedTime(time)
            } else {
                setLockState({ locked: true, lockedBy: false })
            }
        } else {
            if (data.Form.Purpose.trim().toUpperCase() !== 'PERFORMANCE REVIEW') {
                setSavedTime(time)
            } else {
                setLockState({ locked: true, lockedBy: false })
            }
        }
    }

    const releaseLock = (recordId) => {
        if (
            recordId === -1 ||
            !(lockInfo.current.MetaData && lockInfo.current.MetaData[0].HasLock === true)
        ) {
            return
        }
        let startedDate = new Date()

        let url = getBaseURL() + 'webapi/lock/ReleaseRecordLock/' + recordId
        return fetch(url, {
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then((response) => {
                if (response.status === 200) {
                    lockInfo.current = {}
                    props.refLockInfo.current = {}
                    setLockState({ locked: true, lockedBy: false })
                    return true
                } else {
                    let errorEntry = {
                        Reason:
                            'Renew Lock Failed: ' +
                            response.status +
                            ' Fetch submitted at ' +
                            startedDate +
                            ' failed at ' +
                            new Date(),
                        EventName: 'JS Error: ReleaseLock',
                        Description: 'Failed to ReleaseLock Version:' + versionNumber,
                        Username: currentUser,
                    }
                    sendLockLog(errorEntry)
                    return false
                }
            })
            .catch((e) => {
                console.log(e)
            })
    }
    const lockForm = () => {
        setData((data) => {
            let newData = JSON.parse(JSON.stringify(data))
            newData.FormSectionFieldValueView.forEach((x) => (x.LockLevel = -1))
            return newData
        })
    }
    const sendRenew = (attempt2 = false) => {
        if (refRecordId.current !== -1 && !lockState.locked && !showLockedOutScreen) {
            // release lock if we've renewed too many times
            if (renewCount.current >= MAX_RENEW) {
                let res = releaseLock(recordId)
                setActiveScreen(SCREENS.LOCKED)
                return
            }
            if (renewCount.current === WARN_RENEW) {
                setShowReleaseModal(true)
            }
            let startedDate = new Date()
            let url = getBaseURL() + 'webapi/lock/RenewRecordLock/' + refRecordId.current
            fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            })
                .then((response) => {
                    if (response.status === 200) {
                        response.json().then((val) => {
                            lockInfo.current.MetaData = val
                            if (lockInfo.current.MetaData[0].HasLock === false) {
                                setLockState({
                                    lockedBy: response.MetaData[0].LockOwner,
                                    locked: true,
                                })
                                lockForm()
                            }
                        })
                        renewCount.current += 1
                        renewFailCount.current = 0
                    } else {
                        throw new Error(response)
                    }
                })
                .catch((e) => {
                    if (attempt2 === true) {
                        renewFailCount.current += 1
                        if (renewFailCount.current === 2) {
                            setActiveScreen(SCREENS.LOCKED)
                        }
                    }
                    let reason = ''
                    // response error
                    if (e.status) {
                        let response = e
                        reason =
                            'Renew Lock Failed: ' +
                            response.status +
                            ' Fetch submitted at ' +
                            startedDate +
                            ' failed at ' +
                            new Date()
                    }
                    // fetch error
                    else {
                        reason =
                            'Renew Lock Failed: fetch failed. Fetch submitted at ' +
                            startedDate +
                            ' failed at ' +
                            new Date() +
                            ' ' +
                            e.stack
                    }
                    let errorEntry = {
                        Reason: reason,
                        EventName: 'JS Error: RenewLock',
                        Description: 'Failed to RenewLock Version:' + versionNumber + ' ' + e.stack,
                        Username: currentUser,
                    }
                    sendLockLog(errorEntry)
                    // try again once on failure
                    if (attempt2 === false) {
                        sendRenew(true)
                    }
                })
        }
    }
    // if log is false sends existing logs only
    const sendLockLog = (log) => {
        // weird way of managing async because Promises not supported fully on IE
        if (sendingLogs === 1) {
            // if sending add to queue to be added after send
            if (!log) {
                return
            }
            let rawQueue = localStorage.getItem('AWCQueuedLogs')
            let queue = rawQueue ? JSON.parse(rawQueue) : []
            queue.push(log)
            localStorage.setItem('AWCQueuedLogs', JSON.stringify(queue))
            return
        }
        sendingLogs = 1
        let rawLogs = localStorage.getItem('AWCLogs')
        let logs = rawLogs ? JSON.parse(rawLogs) : []
        // remove logs stored from old versions -- check if field exists for logs begore the versionNumber was added
        logs = logs.filter((x) => x.versionNumber && x.versionNumber === versionNumber)
        if (log) {
            log.versionNumber = versionNumber
            logs.push(log)
        }
        if (logs.length === 0) {
            sendingLogs = 0
            return
        }
        let url = getBaseURL() + 'webapi/form/log'
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(logs),
        }).then((response) => {
            // after send append any queued messages to the logs
            let rawQueue = localStorage.getItem('AWCQueuedLogs')
            let queue = rawQueue ? JSON.parse(rawQueue) : []
            localStorage.setItem('AWCQueuedLogs', '[]')

            if (response.status === 200) {
                localStorage.setItem('AWCLogs', JSON.stringify(queue))
            } else {
                // if sending logs fail make a log?
                let errorEntry = {
                    Reason:
                        'Log sending failed with response: ' +
                        response.status +
                        ' Fetch submitted at ' +
                        new Date(),
                    EventName: 'JS Error: SendLog',
                    Description: 'Failed to send Logs Version:' + versionNumber,
                    Username: currentUser,
                }
                logs.push(errorEntry)
                logs.concat(queue)
                localStorage.setItem('AWCLogs', JSON.stringify(logs))
            }
            sendingLogs = 0
        })
    }

    const missingFieldsAlert = (fieldsToFillString) => {
        setAssemblyError(
            `Can't lock current level while fields are required.\nMissing:\n${fieldsToFillString}`
        )
    }

    const handleVerifyLock = (verified) => {
        if (verified) {
            setRecordLockLevel(findCurrentLockLevel(lockedLevels))
            setLockedLevels(updateLockedLevels(newRecordLockLevel, lockedLevels))
            setClearSig(true)
            //log lowering lock level
            let logEntry = {
                EventName: '',
                Username: currentUser,
                Description: '',
                Reason: '',
            }
            if (isLocking) {
                logEntry.EventName = 'FormGeneric: Adding Lock'
                logEntry.Reason = `${currentUser} is locking level ${newRecordLockLevel} for record ${recordId}`
                logEntry.Description = `Locking level ${newRecordLockLevel}: ${versionNumber}`
            } else {
                const signatureField = data.FormSectionFieldValueView.filter(
                    (d) =>
                        d.ValidationType.toUpperCase() === 'PASSWORD SIGNATURE' &&
                        d.LockLevel === newRecordLockLevel
                ).forEach((signature) => {
                    signature.StringFieldValue = ''
                })
                let newData = { signatureField, ...data }
                setData(newData)

                logEntry.EventName = 'FormGeneric: Removing Lock'
                logEntry.Reason = `${currentUser} is unlocking level ${newRecordLockLevel} for record ${recordId}`
                logEntry.Description = `Unlocking level ${newRecordLockLevel}: ${versionNumber}`
            }

            sendLockLog(logEntry)
        } else setAssemblyError('Incorrect Password (Use Form Password)')
    }
    // excludingId is used to lock before a field has been set -- the case for signatures when checking if we can raise the level
    const handleLock = (newRecordLevel, currentRecordLevel, excludingId, sourceSignature) => {
        if (newRecordLevel <= currentRecordLevel && !showLockModal) {
            if (data) {
                const tempField = data.FormSectionFieldValueView.find(
                    (d) => d.FieldNameQuery === 'OnDockDate'
                )
                if (tempField) {
                    // Check if we were at a higher lock level and if we are going to unlock OnDockDate field
                    if (
                        currentRecordLevel > tempField.RecordLockLevel &&
                        newRecordLevel === tempField.RecordLockLevel
                    ) {
                        updateOnDockDate(recordId)
                    }
                }
            }
            let tempIsLocking = checkIfIsLocking(newRecordLevel, lockedLevels)
            if (tempIsLocking) {
                setIsLocking(tempIsLocking)
                let { canRaise, fieldsToFillString } = levelVerification(
                    newRecordLevel,
                    excludingId
                )
                if (canRaise) {
                    setNewRecordLockLevel(newRecordLevel)
                    if (!sourceSignature) {
                        setShowLockModal(true)
                    } else {
                        setLockedLevels(updateLockedLevels(newRecordLevel, lockedLevels))
                        return true
                    }
                } else {
                    missingFieldsAlert(fieldsToFillString)
                    return false
                }
                return false
            } else {
                setIsLocking(tempIsLocking)
                setNewRecordLockLevel(newRecordLevel)
                if (!sourceSignature) {
                    setShowLockModal(true)
                } else {
                    setLockedLevels(updateLockedLevels(newRecordLevel, lockedLevels))
                }

                return true
            }
        } else if (newRecordLevel > currentRecordLevel && !showLockModal) {
            // let user know of any fields required at current level that aren't filled
            // out before allowing an increase in lock level
            let tempIsLocking = checkIfIsLocking(newRecordLevel, lockedLevels)
            if (tempIsLocking) {
                setIsLocking(tempIsLocking)
                let { canRaise, fieldsToFillString } = levelVerification(
                    newRecordLevel,
                    excludingId
                )
                if (canRaise) {
                    setAssemblyInfo(`Increasing Lock Level to ${newRecordLevel.toString()}`)
                    setRecordLockLevel(newRecordLevel)
                    //props.onRecordLockLevelChange(newRecordLevel)
                    setLockedLevels(updateLockedLevels(newRecordLevel, lockedLevels))
                    return true
                } else {
                    setAssemblyError(
                        `Can't raise lock level while fields are required at that level.\nMissing:\n${fieldsToFillString}`
                    )
                    return false
                }
            } else {
                setRecordLockLevel(newRecordLevel)
                setLockedLevels(updateLockedLevels(newRecordLevel, lockedLevels))
                return true
            }
        }
    }

    const handleUnlockAll = () => {
        setRecordLockLevel(0)
        setLockedLevels('0')
        setAssemblyInfo('Removing locks')
        setShowConfirmModal(false)
    }

    const levelVerification = (newRecordLevel, excludingId) => {
        let canRaise = true
        let fieldsToFillString = ''

        missingRequiredLockLevelFields.some((requiredFieldIds, i) => {
            canRaise =
                canRaise &&
                (requiredFieldIds.length === 0 ||
                    (requiredFieldIds.length === 1 &&
                        excludingId !== null &&
                        requiredFieldIds[0] === excludingId))
            requiredFieldIds.forEach((requiredFieldId) => {
                let requiredField = data.FormSectionFieldValueView.find((field) => {
                    return field.FormSectionFieldId === requiredFieldId
                })
                fieldsToFillString += `${requiredField.FieldName}\n`
            })

            // exits the Array.some loop

            return i === newRecordLevel
        })
        return { canRaise, fieldsToFillString }
    }

    const handleSign = (newRecordLevel, currentRecordLevel, fieldId, sourceSignature) => {
        return function () {
            return handleLock(newRecordLevel, currentRecordLevel, fieldId, sourceSignature)
        }
    }

    const handleDateChange = (e) => {
        if (
            !browserSupportsDateInputs() &&
            e.target.value !== '' &&
            e.target.value !== e.target.getAttribute('data-defaultvalue')
        ) {
            if (!isValidDate(e.target.value)) {
                setAssemblyError('Invalid Date! Date must be in mm/dd/yyyy format.')
                e.target.value = e.target.getAttribute('data-defaultvalue')
                return
            } else {
                e.target.setAttribute('data-defaultvalue', e.target.value)
            }
        }
    }

    // disable submit on enter key press
    const handleKeyPress = (e) => {
        const key = e.which || e.keyCode || 0
        key === 13 && e.preventDefault()
    }
    const clearRecord = (x) => {
        x.CreatedBy = ''
        x.CreatedDate = null
        x.RecordId = -1
        const valueFieldName = `${x.DataType.trim()}FieldValue`
        // this isnt a real field value since images go in attachments
        if (valueFieldName !== 'ImageFieldValue') x[valueFieldName] = null
        return x
    }

    // checks that user's browser supports date inputs
    const browserSupportsDateInputs = () => {
        let input = document.createElement('input')
        input.setAttribute('type', 'date')

        let notADateValue = 'not-a-date'
        input.setAttribute('value', notADateValue)

        return input.value !== notADateValue
    }

    // validates that the input string is a valid date formatted as "mm/dd/yyyy"

    const handleFieldInvalid = (e) => {
        if (isFirstError) {
            if (!isElementInViewport(e.target)) {
                e.target.scrollIntoView()
                window.scrollBy(0, -165)
            }
        }
    }

    const disableFilter = (option, props) => true

    const handleFieldChange = (
        RecordId,
        FormSectionFieldId,
        DataType,
        IsRequired,
        RequiredLockLevel,
        ValidationType,
        ChangeStageTo,
        FieldNameQuery
    ) => {
        return (e) => {
            let newValue = ''
            let newMissingRequiredLockLevelFields = missingRequiredLockLevelFields
            let bMissingRequiredLockLevelFieldsChanged = false
            let needsNewTagUID = false
            let deleteTagUid = false
            let orderInfo = {
                ...data.OrderInfo[0],
            }
            const invalidSerialNumbers = ['', 'N/A', 'NA', 'n/a', 'na', 'None', 'NONE']
            let tagUID =
                data.FormSectionFieldValueView?.find((d) => d.FieldNameQuery === 'TagUID')
                    ?.NumericFieldValue || null
            let orderNumber = data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'OrderNumber'
            )?.StringFieldValue
            const serialNumber = data.FormSectionFieldValueView.find(
                (x) =>
                    x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBER' &&
                    x.StringFieldValue &&
                    !invalidSerialNumbers.includes(x.StringFieldValue.trim().toUpperCase())
            )?.StringFieldValue
            let finalSerialNumber = data.FormSectionFieldValueView.find(
                (d) => d.FieldNameQuery === 'FinalSerialNumber'
            )?.StringFieldValue

            if (FieldNameQuery === 'SerialNumber' && finalSerialNumber === '') {
                orderInfo.SerialNumber = e.target.value
            }

            // if (hasBothSerials) {
            //     if (serialNumber != '') {
            //         if (FieldNameQuery === 'SerialNumber') {
            //             orderInfo.SerialNumber = e.target.value
            //         }
            //     }
            // } else {
            //     if (
            //         FieldNameQuery === 'SerialNumber' ||
            //         FieldNameQuery === 'SerialNumberOriginal'
            //     ) {
            //         orderInfo.SerialNumber = e.target.value
            //     }
            // }
            if (FieldNameQuery === 'TagUID') {
                orderInfo.AWCAssemblyId = e.target.value
            }
            if (FieldNameQuery === 'TagNumber') {
                orderInfo.Tag = e.target.value
            }
            if (
                orderNumber &&
                orderInfo.ServiceType != 'A' &&
                FieldNameQuery === 'SerialNumber' &&
                !finalSerialNumber &&
                tagUID !== ''
            ) {
                if (
                    e.target.value &&
                    e.target.value != '' &&
                    e.target.value != serialNumber &&
                    !invalidSerialNumbers.includes(e.target.value?.toUpperCase())
                ) {
                    needsNewTagUID = true
                } else {
                    if (e.target.value != serialNumber && tagUID > 0) {
                        deleteTagUid = true
                    }
                }
            }

            if (
                FieldNameQuery === 'FinalSerialNumber' &&
                e.target.value != serialNumber &&
                e.target.value != finalSerialNumber
            ) {
                if (e.target.value && e.target.value != '') {
                    needsNewTagUID = true
                    orderInfo.SerialNumber = e.target.value
                }
            }
            if (e && e.target) {
                newValue =
                    DataType.trim().toUpperCase() === 'BOOLEAN'
                        ? e.target.checkedValue
                        : e.target.value
                if (typeof newValue === 'string') {
                    let unicodeChars = getUnicodeChars(newValue)
                    // Ignore unicode for dropdowns
                    if (
                        unicodeChars.length > 0 &&
                        ValidationType.toUpperCase() !== 'DROP-DOWN LIST' &&
                        ValidationType.toUpperCase() !== 'MULTI-SELECT'
                    ) {
                        let replaceValue = replaceUnicode(newValue)
                        let remainingUnicodeChars = getUnicodeChars(replaceValue)
                        if (remainingUnicodeChars.length > 0) {
                            // fix up value so input fields are consistent with stored data in react
                            let oldValue = data.FormSectionFieldValueView.find(
                                (x) => x.FormSectionFieldId === FormSectionFieldId
                            )
                            let actualValue =
                                oldValue.StringFieldValue ||
                                oldValue.NumericFieldValue ||
                                oldValue.OptionValue
                            e.target.value = actualValue ? actualValue : null
                            setAssemblyError(
                                'Some characters you tried to enter are invalid. Please manually type values if you were trying to copy and paste. Here are the invalid characters: (' +
                                remainingUnicodeChars +
                                ')'
                            )
                            return
                        } else {
                            newValue = replaceValue
                        }
                    }
                }
                if (newValue !== '' && !validateInputValue(DataType, newValue)) {
                    e.target.setCustomValidity(`Invalid ${DataType.toLowerCase()} format.`)
                    bMissingRequiredLockLevelFieldsChanged = modifyMissingRequiredLockLevelFields(
                        newMissingRequiredLockLevelFields,
                        FormSectionFieldId,
                        RequiredLockLevel,
                        'add'
                    )
                } else if (newValue === null || newValue === '') {
                    if (IsRequired) e.target.setCustomValidity('This is a required field.')
                    if (RequiredLockLevel > 0)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                FormSectionFieldId,
                                RequiredLockLevel,
                                'add'
                            )
                } else {
                    e.target.setCustomValidity('')

                    bMissingRequiredLockLevelFieldsChanged = modifyMissingRequiredLockLevelFields(
                        newMissingRequiredLockLevelFields,
                        FormSectionFieldId,
                        RequiredLockLevel,
                        'remove'
                    )
                }
            } else {
                if (e === '')
                    bMissingRequiredLockLevelFieldsChanged = modifyMissingRequiredLockLevelFields(
                        newMissingRequiredLockLevelFields,
                        FormSectionFieldId,
                        RequiredLockLevel,
                        'add'
                    )
                else
                    bMissingRequiredLockLevelFieldsChanged = modifyMissingRequiredLockLevelFields(
                        newMissingRequiredLockLevelFields,
                        FormSectionFieldId,
                        RequiredLockLevel,
                        'remove'
                    )

                newValue = e
            }
            if (bMissingRequiredLockLevelFieldsChanged)
                setMissingRequiredLockLevelFields(newMissingRequiredLockLevelFields)

            let valRec = data.FormSectionFieldValueView.find(
                (x) => x.FormSectionFieldId === FormSectionFieldId && x.RecordId === RecordId
            )
            if (valRec) {
                valRec.LastModifiedDate = new Date()
                if (typeof newValue !== 'object' || newValue === null) {
                    switch (DataType.toUpperCase()) {
                        case 'NUMERIC':
                            valRec.NumericFieldValue = newValue.toString()
                            break
                        case 'MEMO':
                            valRec.MemoFieldValue = newValue
                            break
                        case 'BOOLEAN':
                            valRec.BooleanFieldValue = newValue
                            break
                        case 'DATE':
                            valRec.DateFieldValue = newValue
                            break
                        default:
                            valRec.StringFieldValue = newValue
                    }
                } else {
                    // giving all uniqueId here -- leaving diffing of MultiValue for save function
                    let selectedValues = newValue
                    let newValueId =
                        Math.min(
                            ...data.FormSectionFieldMultiValue.map((y) => {
                                return y.ValueId
                            }),
                            0
                        ) - 1
                    data.FormSectionFieldMultiValue = selectedValues.map((row) => {
                        let myValueId = newValueId
                        newValueId -= 1
                        return {
                            RecordId,
                            FormSectionFieldId,
                            ValueId: myValueId,
                            StringFieldValue: row.value,
                        }
                    })
                }

                let newFSFVV = data.FormSectionFieldValueView
                // Check if changed field is password signature
                if (valRec.ValidationType === 'Password Signature') {
                    // Get current field
                    const currentFieldId = parseInt(valRec.FormSectionFieldId)

                    newFSFVV.map((d, index) => {
                        // Check for current field
                        if (d.FormSectionFieldId === currentFieldId) {
                            // Grab next field
                            const nextField = newFSFVV[index + 1]

                            // Check if next field exists
                            if (nextField) {
                                // Check if it's a date and in the same FormSectionId
                                if (
                                    nextField.DataType === 'Date' &&
                                    nextField.FormSectionId === valRec.FormSectionId
                                ) {
                                    const todaysDate = new Date().toISOString()
                                    nextField.DateFieldValue = todaysDate
                                } else {
                                    // Check if the previous field is a date and in the same FormSectionId
                                    if (index > 0) {
                                        // Grab previous field
                                        const previousField = newFSFVV[index - 1]
                                        if (previousField) {
                                            if (
                                                previousField.DataType === 'Date' &&
                                                previousField.FormSectionId === valRec.FormSectionId
                                            ) {
                                                const todaysDate = new Date().toISOString()
                                                previousField.DateFieldValue = todaysDate
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
                if (AVERAGING_FIELDS[FieldNameQuery]) {
                    let fieldsToAverage = data.FormSectionFieldValueView.filter(
                        (row) => row.FieldNameQuery === FieldNameQuery
                    )
                    let averageRow = newFSFVV.find(
                        (row) => row.FieldNameQuery === VALUE_AVERAGE_MAP[FieldNameQuery]
                    )

                    if (fieldsToAverage.every((row) => !isNaN(parseFloat(row.NumericFieldValue)))) {
                        let total = 0
                        fieldsToAverage.forEach(
                            (row) => (total += parseFloat(row.NumericFieldValue))
                        )
                        let averageValue = total / fieldsToAverage.length
                        averageRow.NumericFieldValue = numericStepToFixed(
                            averageValue,
                            averageRow.NumericStep
                        )
                    } else {
                        if (averageRow) {
                            averageRow.NumericFieldValue = undefined
                        }
                    }
                }
                // SetPressureUOM or BackPressureUOM
                // current place
                if (FREEZE_UOM_START[FieldNameQuery]) {
                    let startRow = data.FormSectionFieldValueView.find(
                        (row) => row.FieldNameQuery === FieldNameQuery
                    )

                    let rowToFreeze = newFSFVV.find(
                        (row) =>
                            row.FieldNameQuery === FREEZE_UOM_MAP[FieldNameQuery] &&
                            row.ValidationType === 'Drop-Down List'
                    )
                    if (startRow && rowToFreeze) {
                        rowToFreeze.StringFieldValue = startRow.StringFieldValue
                            ? startRow.StringFieldValue
                            : null
                    }
                }

                if (deleteTagUid) {
                    newFSFVV.find((d) => d.FieldNameQuery === 'TagUID').NumericFieldValue = 0
                    orderInfo.AWCAssemblyId = ''
                }
                data.FormSectionFieldValueView = newFSFVV
                data.OrderInfo[0] = orderInfo
                setData(data)
                if (needsNewTagUID) {
                    handleAssemblyIDSelection(
                        data,
                        setAWCAssemblyUIDList,
                        setData,
                        setAssemblyInfo,
                        setAssemblyError,
                        props.handleSubmitWithData
                    )
                }
                setForceUpdate(Math.random())
                setFieldChanged(true)
            }
            // refresh renewCount counter
            renewCount.current = 0
            sendRenew()
            props.onFormFieldChange(data)
        }
    }

    const getUnicodeChars = (s) => {
        // matches nonascii
        let match = s.match(/[\u{0080}-\u{FFFF}]/gu, '')

        return match ? match : []
    }

    const replaceUnicode = (s) => {
        let newString = s
        newString = newString.replace(/\u2018/g, "'") //left single quotation mark
        newString = newString.replace(/\u2019/g, "'") //Right single quotation mark
        newString = newString.replace(/\u2026/g, '...') //Horizontal Ellipse
        newString = newString.replace(/\u201C/g, '"') //Left double quotation mark
        newString = newString.replace(/\u201D/g, '"') //Right double quotation mark
        newString = newString.replace(/\u2122/g, '(TM)') //Trademark sign
        newString = newString.replace(/\u00A9/g, '(c)') //Copywrite sign
        newString = newString.replace(/\u00AE/g, '(r)') //registered sign
        newString = newString.replace(/\u00BC/g, '1/4') //Fraction one quarter
        newString = newString.replace(/\u00BD/g, '1/2') //Fraction one half
        newString = newString.replace(/\u00BE/g, '3/4') //Fraction three quarters
        newString = newString.replace(/\u203A/g, '>') //Single right pointing angle quotation
        newString = newString.replace(/\u2039/g, '<') //Single left pointing angle quotation
        newString = newString.replace(/\u00B0/g, 'deg') //degree symbol
        newString = newString.replace(/\u00BA/g, 'deg') //degree symbol
        newString = newString.replace(/\u00B4/g, "'") //Acute accent - spacing acute
        newString = newString.replace(/\u00A0/g, ' ') //No-break space
        newString = newString.replace(/\u00B7/g, '-') //Middle dot - Georgian comma
        newString = newString.replace(/\u2022/g, '-') //Bullet
        newString = newString.replace(/\u2013/g, '-') //En dash
        newString = newString.replace(/\u2014/g, '-') //Em dash
        newString = newString.replace(/\u00EA/g, '^') //Modifier letter circumflex accent
        newString = newString.replace(/\u02DC/g, '~') //Small tilde

        return newString
    }

    const handleGalleryAddPicture = (fieldId) => {
        return (dataUri, selectedOptions, caption) => {
            numberPicturesSending += 1
            var timeSent = new Date()
            fetchWithTimeout(
                `${getBaseURL()}webapi/form/FormAttachment/`,
                {
                    method: 'POST',
                    body: JSON.stringify(dataUri),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                },
                TIMEOUT_SECONDS * 1000
            )
                .then((response) => {
                    if (response.ok) return response.json()

                    return response.text()
                })
                .then((responseJson) => {
                    if (typeof responseJson === 'string') throw new Error(responseJson)

                    const newAttachmentRow = responseJson[0]
                    if (!data.FormSectionFieldAttachment) {
                        data.FormSectionFieldAttachment = []
                    }
                    let attRows = data.FormSectionFieldAttachment.filter(
                        (x) => x.FormSectionFieldId === fieldId
                    )
                    let length = attRows.length

                    numberPicturesSending -= 1
                    setData((data) => {
                        data.FormSectionFieldAttachment.push({
                            ContentType: newAttachmentRow.ContentType,
                            FormSectionFieldId: fieldId,
                            FriendlyFilename: newAttachmentRow.OriginalName,
                            Caption: caption,
                            RecordId: props.recordid,
                            SystemFilename: newAttachmentRow.FilePathSeed,
                            SystemFilenameExtension: newAttachmentRow.Extension,
                            OrderBy: length + 1,
                            UploadedTimestamp: newAttachmentRow.UploadedTimestamp,
                        })
                        selectedOptions.map((selectedOption) => {
                            data.FormSectionFieldAttachmentMultiValue.push({
                                RecordId: props.recordid,
                                FormSectionFieldId: fieldId,
                                SystemFilename: newAttachmentRow.FilePathSeed,
                                StringFieldValue: selectedOption.value,
                                ValueId: -(data.FormSectionFieldAttachmentMultiValue.length + 1),
                            })
                            return null
                        })
                        return { ...data }
                    })
                    setFieldChanged(true)
                })
                .catch((e) => {
                    let timeFailed = new Date()
                    let errorEntry = `Reason: addPicture send failed. Error in handleAddPicture. Fetch submitted at ${timeSent} Error received at ${timeFailed} probably network: ${e.name} ${e.message} Picture Size (chars):' +
                            ${dataUri.length} 
                            Stack:
                            ${e.stack}
                        EventName: JS Error: HandleAddPictureCatch,
                        Description:
                            addPicture send failed. Error in handleAddPicture Version:
                            ${versionNumber},
                        Username: ${currentUser}`

                    sendLog(errorEntry)

                    numberPicturesSending -= 1
                    setAssemblyError('We encounter an issue, try again later')
                })
        }
    }

    const handleGalleryAttachmentUpdateFields = (fieldId) => {
        return (systemFilename, selectedOptions, caption) => {
            if (!data.FormSectionFieldAttachment) {
                data.FormSectionFieldAttachment = []
            }
            if (!data.FormSectionFieldAttachmentMultiValue) {
                data.FormSectionFieldAttachmentMultiValue = []
            }

            setData((data) => {
                data.FormSectionFieldAttachment.find(
                    (x) => x.FormSectionFieldId === fieldId && x.SystemFilename === systemFilename
                ).Caption = caption

                // remove any values from data that belong to the current fieldId/systemFilename AND are no longer present in the selectedOptions
                let attMVRows = data.FormSectionFieldAttachmentMultiValue.filter(
                    (x) =>
                        x.FormSectionFieldId === fieldId &&
                        x.SystemFilename === systemFilename &&
                        !selectedOptions.find((z) => z.value === x.StringFieldValue)
                )

                if (attMVRows) {
                    if (!data.FormSectionFieldAttachmentMultiValueDeleted)
                        data.FormSectionFieldAttachmentMultiValueDeleted = []

                    for (let i = attMVRows.length - 1; i >= 0; i--) {
                        data.FormSectionFieldAttachmentMultiValueDeleted.push(attMVRows[i])
                        const mvIdx = data.FormSectionFieldAttachmentMultiValue.indexOf(
                            attMVRows[i]
                        )
                        data.FormSectionFieldAttachmentMultiValue.splice(mvIdx, 1)
                    }
                }

                // add any values that are present in selectedOptions, but aren't present in data
                selectedOptions
                    .filter(
                        (x) =>
                            !data.FormSectionFieldAttachmentMultiValue.find(
                                (y) =>
                                    y.FormSectionFieldId === fieldId &&
                                    y.SystemFilename === systemFilename &&
                                    y.StringFieldValue === x.value
                            )
                    )
                    .forEach((y) => {
                        data.FormSectionFieldAttachmentMultiValue.push({
                            RecordId: parseInt(props.recordid),
                            FormSectionFieldId: parseInt(fieldId),
                            SystemFilename: parseInt(systemFilename),
                            ValueId: -(data.FormSectionFieldAttachmentMultiValue.length + 1),
                            StringFieldValue: y.value,
                        })
                    })

                return { ...data }
            })
            setFieldChanged(true)
        }
    }

    const handleGalleryImageSort = (FormSectionFieldId, OldIndex, NewIndex) => {
        const bIncreaseOrderBys = NewIndex < OldIndex && NewIndex !== -1

        let attRows = data.FormSectionFieldAttachment.filter(
            (x) => x.FormSectionFieldId === FormSectionFieldId
        )
        attRows.map((attRow) => {
            if (attRow.OrderBy === OldIndex) attRow.OrderBy = NewIndex
            else if (bIncreaseOrderBys) {
                if (attRow.OrderBy >= NewIndex && attRow.OrderBy < OldIndex) attRow.OrderBy += 1
            } else if ((attRow.OrderBy <= NewIndex || NewIndex === -1) && attRow.OrderBy > OldIndex)
                attRow.OrderBy -= 1

            return true
        })

        data.FormSectionFieldAttachment.sort(dynamicSort('OrderBy'))

        setData((data) => data)
    }

    const dynamicSort = (property) => {
        let sortOrder = 1
        if (property[0] === '-') {
            sortOrder = -1
            property = property.substr(1)
        }
        return function (a, b) {
            /* next line works with strings and numbers,
             * and you may want to customize it to your needs
             */
            const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
            return result * sortOrder
        }
    }

    const handleGalleryOnClickRemoveSelectedPictures = (deletedImages) => {
        if (!data.FormSectionFieldAttachmentDeleted) data.FormSectionFieldAttachmentDeleted = []

        deletedImages.forEach((deletedImage) => {
            let attRow = data.FormSectionFieldAttachment.find(
                (x) => x.SystemFilename === deletedImage.SystemFilename
            )
            if (attRow) {
                data.FormSectionFieldAttachmentDeleted.push(attRow)
                const imgIdx = data.FormSectionFieldAttachment.indexOf(attRow)
                data.FormSectionFieldAttachment.splice(imgIdx, 1)
            }
            let attMVRows = data.FormSectionFieldAttachmentMultiValue.filter(
                (x) => x.SystemFilename === deletedImage.SystemFilename
            )
            if (attMVRows) {
                if (!data.FormSectionFieldAttachmentMultiValueDeleted)
                    data.FormSectionFieldAttachmentMultiValueDeleted = []
                for (let i = attMVRows.length - 1; i >= 0; i--) {
                    data.FormSectionFieldAttachmentMultiValueDeleted.push(attMVRows[i])
                    const mvIdx = data.FormSectionFieldAttachmentMultiValue.indexOf(attMVRows[i])
                    data.FormSectionFieldAttachmentMultiValue.splice(mvIdx, 1)
                }
            }
        })

        setData(data)
        setFieldChanged(true)
    }

    const signPreCheck = (newLockLevel, thisId, fdata) => {
        return () => {
            let levelVerified = levelVerification(newLockLevel, thisId)
            if (!levelVerified.canRaise) {
                missingFieldsAlert(levelVerified.fieldsToFillString)
            }
            return levelVerified
        }
    }

    const fieldIsVisibleInCurrentFormView = (fieldId) => {
        return (
            parseInt(formViewId) === 0 ||
            data.FormViewField.find(
                (x) =>
                    parseInt(x.FormViewId) === parseInt(formViewId) &&
                    parseInt(x.FormSectionFieldId) === parseInt(fieldId)
            )
        )
    }

    const canShowSection = (sectionId) => {
        if (!visibleSectionFields.has(sectionId)) return true

        const field = data.FormSectionFieldValueView.find(
            (x) => parseInt(x.FormSectionFieldId) === parseInt(visibleSectionFields.get(sectionId))
        )
        if (!field) return true
        switch (field.DataType.toUpperCase()) {
            case 'NUMERIC':
                return field.NumericFieldValue && field.NumericFieldValue !== 0
            case 'MEMO':
                return field.MemoFieldValue && field.MemoFieldValue !== ''
            case 'BOOLEAN':
                return field.BooleanFieldValue && field.BooleanFieldValue === true
            case 'DATE':
                return field.DateFieldValue !== null
            default:
                return field.StringFieldValue && field.StringFieldValue !== ''
        }
    }

    const renderSectionTitle = (key, Section) => {
        return (
            <Sticky topOffset={-85} tagtype='summary' key={'sectionTitle' + key}>
                {({ style }) => (
                    <h3
                        style={{
                            ...style,
                            backgroundColor: 'white',
                            top: '85px',
                            zIndex: 1,
                        }}
                    >
                        {Section}
                    </h3>
                )}
            </Sticky>
        )
    }

    const renderSectionTitleContainer = (key, SectionChildren) => {
        return (
            <StickyContainer
                id={`section${key}`}
                key={`sectionTitleContainer${key}`}
                className='section'
                tagtype='details'
                open='open'
            >
                {SectionChildren}
            </StickyContainer>
        )
    }

    const renderTable = (children, tableInfo) => {
        let { Rows, Columns } = { ...tableInfo }
        Rows = Math.ceil(children.length / Columns)
        let rows = [...Array(Rows).keys()]
        let cols = [...Array(Columns).keys()]
        let colWidth = 100 / Columns

        return (
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${Columns}, max-content)`,
                    rowGap: 10,
                    columnGap: 15,
                    marginBottom: 10,
                }}
            >
                {rows.map((rowNum) => (
                    <React.Fragment key={`row-${rowNum}`}>
                        {cols.map((colNum) => {
                            const child = children[rowNum * Columns + colNum]
                            return (
                                <div key={`col-${rowNum}-${colNum}`}>
                                    {child ? (
                                        <div>
                                            <div>{child[0]}</div>
                                            <div>{child[1]}</div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div>
                                                <br />
                                            </div>
                                            <div>
                                                <br />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </React.Fragment>
                ))}
            </div>
        )
        return (
            <div>
                {rows.map((rowNum) => {
                    return (
                        <div>
                            {cols.map((colNum) => {
                                return (
                                    <div style={{ width: `${colWidth}%`, display: 'inline-block' }}>
                                        {children[rowNum * Columns + colNum]}
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }
    const validateInputValue = (dataType, newValue) => {
        if (dataType.toUpperCase() === 'DATE') {
            const d = new Date(newValue)
            if (!d instanceof Date || isNaN(d)) return false
        }
        if (dataType.toUpperCase() === 'NUMERIC') {
            if (isNaN(newValue) || !isFinite(newValue)) return false
        }

        return true
    }

    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect()

        return (
            rect.top >= 165 &&
            rect.left >= 0 &&
            rect.bottom <=
            (window.innerHeight ||
                document.documentElement.clientHeight) /*or $(window).height() */ &&
            rect.right <=
            (window.innerWidth ||
                document.documentElement.clientWidth) /*or $(window).width() */
        )
    }

    const handleUIDSearchClick = () => {
        let returnData = []

        let tagNumber = data.FormSectionFieldValueView.find(
            (x) => x.FieldNameQuery.trim().toUpperCase() === 'TAGNUMBER'
        )
        tagNumber = tagNumber ? tagNumber.StringFieldValue : ''
        returnData.push(tagNumber)

        let serialNumber = data.FormSectionFieldValueView.find(
            (x) => x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBER'
        )
        serialNumber = serialNumber ? serialNumber.StringFieldValue : ''
        returnData.push(serialNumber)

        let tagNumberOriginal = data.FormSectionFieldValueView.find(
            (x) => x.FieldNameQuery.trim().toUpperCase() === 'TAGNUMBERORIGINAL'
        )
        tagNumberOriginal = tagNumberOriginal ? tagNumberOriginal.StringFieldValue : ''
        returnData.push(tagNumberOriginal)

        let serialNumberOriginal = data.FormSectionFieldValueView.find(
            (x) => x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBERORIGINAL'
        )
        serialNumberOriginal = serialNumberOriginal ? serialNumberOriginal.StringFieldValue : ''
        returnData.push(serialNumberOriginal)

        return returnData
    }

    const getFieldEventAction = (fdata, newValue) => {
        let fieldEvent = data.FieldEvent.find(
            (row) => row.FormSectionFieldId === fdata.FormSectionFieldId
        )
        let didAction = false
        // Send report to IAM
        // If yes - Send report and stage change to "Waiting on Parts"
        // If no - Stage change to Repairing
        // mess because there are 4versions of this form that they're testing
        if (fdata.FieldNameQuery === 'IAMReport') {
            if (newValue) {
                eventQueueRef.current.enqueueEvent(
                    EVENTS.CHANGE_STAGE,
                    {
                        ChangeStageTo: 'Waiting on Components',
                        CanCompleteAs: data.OrderInfo[0].CanCompleteAs,
                    },
                    fdata.FormSectionFieldId
                )
                eventQueueRef.current.enqueueEvent(
                    EVENTS.SEND_STAGE_EMAIL,
                    'Evaluation Complete',
                    fdata.FormSectionFieldId
                )
            } else {
                eventQueueRef.current.enqueueEvent(
                    EVENTS.CHANGE_STAGE,
                    {
                        ChangeStageTo: 'Repairing',
                        CanCompleteAs: data.OrderInfo[0].CanCompleteAs,
                    },
                    fdata.FormSectionFieldId
                )
            }
            didAction = true
        }
        if (
            (fdata.FieldNameQuery === 'PreTestSeatLeak' && newValue === 'Fail') ||
            (fdata.FieldNameQuery === 'PreTestPressure' && newValue === 'Fail') ||
            (fdata.FieldNameQuery === 'PreTestVacuumLeakRate' && newValue === 'Fail')
        ) {
            //(fdata.FieldNameQuery === "PreTestSeatLeak" && newValue === "Fail") ||
            let type =
                fdata.FieldNameQuery === 'PreTestSeatLeak'
                    ? 'leak'
                    : fdata.FieldNameQuery === 'PreTestPressure'
                        ? 'pressure'
                        : 'vacuumleak'
            eventQueueRef.current.enqueueEvent(
                EVENTS.PRETEST_FAIL_EMAIL,
                { recordId: fdata.RecordId, type },
                fdata.FormSectionFieldId
            )
            didAction = true
        }
        if (!fieldEvent) return didAction
        if (fieldEvent.Name === 'SendSDSConditional') {
            let ifTrue = wordToBoolean(
                data.FieldEventParameters.find(
                    (row) =>
                        row.FieldEventId === fieldEvent.FieldEventId &&
                        row.Parameter === 'TrueValue'
                ).Value
            )
            let ifFalse = wordToBoolean(
                data.FieldEventParameters.find(
                    (row) =>
                        row.FieldEventId === fieldEvent.FieldEventId &&
                        row.Parameter === 'FalseValue'
                ).Value
            )

            if (newValue === true && ifTrue) {
                eventQueueRef.current.enqueueEvent(
                    EVENTS.SDS_EMAIL,
                    fdata.RecordId,
                    fdata.FormSectionFieldId
                )
                didAction = true
            }
            if (newValue === false && ifFalse) {
                eventQueueRef.current.enqueueEvent(
                    EVENTS.SDS_EMAIL,
                    fdata.RecordId,
                    fdata.FormSectionFieldId
                )
                didAction = true
            }
        }

        return didAction
    }
    // force set on picture changes
    const stageChange = (fdata, newValue, force) => {
        if (
            data.OrderInfo &&
            data.OrderInfo[0].CanCompleteAs === '' &&
            fdata.ChangeStageTo &&
            fdata.ChangeStageTo.toUpperCase().startsWith('COMPLETED')
        ) {
            return ERRORS.CANT_COMPLETE
        }

        if (fdata.ChangeStageTo != '') {
            data.OrderInfo[0].OrderTagStage = fdata.ChangeStageTo
        }

        let oldMultiValues = []
        props.defaultData.FormSectionFieldMultiValue.forEach((row) => {
            if (row.FormSectionFieldId === fdata.FormSectionFieldId) {
                oldMultiValues.push(row.StringFieldValue)
            }
        })
        let newMultiValues = []
        data.FormSectionFieldMultiValue.forEach((row) => {
            if (row.FormSectionFieldId === fdata.FormSectionFieldId) {
                newMultiValues.push(row.StringFieldValue)
            }
        })
        let multivaluesChanged = newMultiValues.some(
            (newValue) => !oldMultiValues.find((oldValue) => oldValue === newValue)
        )

        multivaluesChanged =
            multivaluesChanged ||
            oldMultiValues.some(
                (oldValue) => !newMultiValues.find((newValue) => oldValue === newValue)
            )
        if (
            force ||
            multivaluesChanged ||
            AVERAGING_FIELDS[fdata.FieldNameQuery] ||
            (newValue !== '' && newValue !== null && newValue !== undefined)
        ) {
            // give it a fake event
            // markde leted for cleanup on return of new data
            setData((data) => {
                data.FormSectionFieldValueViewDeleted &&
                    data.FormSectionFieldValueViewDeleted.forEach((row) => (row.toClean = true))
                data.FormSectionFieldMultiValueDeleted &&
                    data.FormSectionFieldMultiValueDeleted.forEach((row) => (row.toClean = true))
                data.FormSectionFieldAttachmentDeleted &&
                    data.FormSectionFieldAttachmentDeleted.forEach((row) => (row.toClean = true))
                data.FormSectionFieldAttachmentMultiValueDeleted &&
                    data.FormSectionFieldAttachmentMultiValueDeleted.forEach(
                        (row) => (row.toClean = true)
                    )
                return { ...data }
            })
            try {
                let didAction = getFieldEventAction(fdata, newValue)
                // they want special for Send Report to IAM Review -- temp to stop holdup of insight
                if (fdata.ChangeStageTo && fdata.FieldNameQuery !== 'IAMReport') {
                    if (props.recordid > 0 && data.OrderInfo && data.OrderInfo[0].OrderTagId > 0) {
                        eventQueueRef.current.enqueueEvent(
                            EVENTS.CHANGE_STAGE,
                            {
                                ChangeStageTo: fdata.ChangeStageTo,
                                CanCompleteAs: data.OrderInfo[0].CanCompleteAs,
                            },
                            fdata.FormSectionFieldId
                        )
                    }
                }
                if (fdata.ClockAction) {
                    if (fdata.ClockAction === 'STOP')
                        if (
                            props.recordid > 0 &&
                            data.OrderInfo &&
                            data.OrderInfo[0].OrderTagId > 0
                        )
                            eventQueueRef.current.enqueueEvent(
                                EVENTS.STOP_TIMER,
                                null,
                                fdata.FormSectionFieldId
                            )
                    if (fdata.ClockAction === 'START')
                        if (
                            props.recordid > 0 &&
                            data.OrderInfo &&
                            data.OrderInfo[0].OrderTagId > 0
                        )
                            eventQueueRef.current.enqueueEvent(
                                EVENTS.START_TIMER,
                                fdata.ChangeStageTo,
                                fdata.FormSectionFieldId
                            )
                }

                let fieldNameQuery = fdata.FieldNameQuery.trim().toUpperCase()
                let updateQueryFields = {
                    TAGNUMBER: true,
                    SERIALNUMBER: true,
                    TAGUID: true,
                }

                if (updateQueryFields[fieldNameQuery] && newValue) {
                    eventQueueRef.current.enqueueEvent(
                        EVENTS.UPDATE_QUERYFIELD,
                        { queryField: fdata.FieldNameQuery, newValue: newValue },
                        fdata.FormSectionFieldId
                    )
                    didAction = true
                }
            } catch (e) { }
        }
    }

    const renderData = GetRenderData(
        data,
        numLevels,
        missingRequiredLockLevelFields,
        handleFieldChange,
        handleSign,
        recordLockLevel,
        props,
        writer,
        handleFieldInvalid,
        setIsFirstError,
        fieldIsVisibleInCurrentFormView,
        canShowSection,
        renderTable,
        renderSectionTitleContainer,
        renderSectionTitle,
        stageChange,
        browserSupportsDateInputs,
        handleDateChange,
        handleKeyPress,
        setCurrentModal,
        disableFilter,
        signPreCheck,
        handleUIDSearchClick,
        handleGalleryAddPicture,
        handleGalleryAttachmentUpdateFields,
        handleGalleryImageSort,
        handleGalleryOnClickRemoveSelectedPictures,
        disableSubmits,
        formOrError,
        signatureFields,
        setSignatureFields,
        setMissingRequiredLockLevelFields,
        setNumLevels,
        requiredLockLevelFields,
        lockedLevels,
        appLock,
        handleAssemblySelectionWrapper,
        aWCAssemblyUIDList,
        newAssemblyIDClick,
        handleAssemblyIdChange,
        handleQROpenModal,
        formId,
        setFormViewId,
        fieldChanged,
        recordId,
        setIsMenuOpen,
        isMenuOpen,
        lockState,
        lockedLevelsArray,
        refRecordId,
        isQRModalVisible,
        handleQRCloseModal,
        handleScanComplete,
        setAssemblyError,
        isAssemblySearchModalVisible,
        handleAssemblyResultsCloseModal,
        apiData,
        handleAssemblySearchConfirm,
        isAssemblyModalVisible,
        handleAssemblyCloseModal,
        showAssemblyAlert,
        assemblyError,
        saveButtonRendered,
        props.showVersionOutOfDateAlert,
        showAssemblyInfo,
        assemblyInfo,
        saving,
        savedTime,
        setSaveButtonRendered,
        onSubmit,
        currentUser,
        versionNumber,
        setAssemblyInfo,
        handleReadOnly,
        isPOModalVisible,
        handlePOCloseModal,
        handlePOComplete,
        showAssemblyListModal,
        setShowAssemblyListModal,
        canUnlock,
        setShowConfirmModal
    )

    // if no data has been returned yet, don't render anything
    if (data === false) {
        return null
    } else {
        switch (activeScreen) {
            case SCREENS.DEFAULT:
                return (
                    <>
                        <LockModal
                            showModal={showLockModal}
                            closeModal={() => setShowLockModal(false)}
                            verify={handleVerifyLock}
                            formId={props.formid}
                        />
                        <ReleaseModal
                            showModal={showReleaseModal}
                            closeModal={() => setShowReleaseModal(false)}
                            close={() => setShowReleaseModal(false)}
                        />
                        <ConfirmModal
                            showModal={showConfirmModal}
                            handleConfirmClose={handleConfirmClose}
                            title=''
                            message='Are you sure you want to remove the locks?'
                            handleConfirmClick={handleUnlockAll}
                        />
                        {renderData()}
                        {props.recordid > 0 &&
                            data.OrderInfo &&
                            data.OrderInfo[0].OrderTagId > 0 &&
                            currentUser !== 'NOT SET' && (
                                <TimerWidget
                                    ref={widgetRef}
                                    orderTagId={data.OrderInfo[0].OrderTagId}
                                    orderTagStage={data.OrderInfo[0].OrderTagStage}
                                    noTimers={false}
                                    currentUser={currentUser}
                                    recordId={props.recordid}
                                />
                            )}
                        {currentModal}
                    </>
                )
            case SCREENS.LOCKED:
                return (
                    <div
                        className='alert alert-warning'
                        role='alert'
                        style={{
                            textAlign: 'center',
                            marginTop: 60,
                        }}
                    >
                        <h3>Session Expired</h3>
                        <p style={{ marginBottom: 0 }}>
                            Your session has timed out. To pick up where you left off, in .NET go
                            to:
                        </p>
                        <p style={{ marginTop: 0 }}>
                            <b>Shop-&gt;Tags-&gt;Recover Form</b>
                        </p>
                    </div>
                )
            case SCREENS.WRONG_USER:
                return (
                    <div
                        className='alert alert-danger'
                        role='alert'
                        style={{
                            textAlign: 'center',
                            marginTop: 60,
                        }}
                    >
                        <h3>Unauthorized</h3>
                        <p>You do not have read or write access to this form</p>
                    </div>
                )
            case SCREENS.NO_RECORD:
                return (
                    <div
                        className='alert alert-danger'
                        role='alert'
                        style={{
                            textAlign: 'center',
                            marginTop: 60,
                        }}
                    >
                        <h3>Record does not exist</h3>
                        <p>If you were linked here, the record was probably deleted</p>
                    </div>
                )
            default:
                return <div></div>
        }
    }
})
